import { type ReactNode } from 'react'
import { ButtonAdd } from 'app/components'
import { Group } from '@mantine/core'
import { useToastError } from '@hooks'
import { useUpdateCompany } from '@front/model'
import { useTeamHierarchyContext } from '../TeamHierarchyContext'

export const AddTeamLevel = ({ level }: { level: 'high' | 'low' }): ReactNode => {
  const { company, withPermissions, canEdit } = useTeamHierarchyContext()
  const { update, isUpdating, error } = useUpdateCompany()
  useToastError(error)

  if (withPermissions || !canEdit) return null

  const { highestTeamLevel = 1, lowestTeamLevel = 1 } = company

  if (level === 'low' && lowestTeamLevel <= 1) return null

  const handleAddLevel = (): void => {
    if (level === 'high') {
      update({ ...company, highestTeamLevel: highestTeamLevel + 1 })
    } else {
      update({ ...company, lowestTeamLevel: lowestTeamLevel - 1 })
    }
  }

  return (
    <Group>
      <ButtonAdd loading={isUpdating} variant='secondary' onClick={handleAddLevel}>
        Add {level === 'high' ? 'Higher' : 'Lower'} Level
      </ButtonAdd>
    </Group>
  )
}
